import styled from 'styled-components'

import { ReactComponent as DownloadCircleIcon } from '@sketch/icons/arrow-down-circle-17'

export const DownloadIcon = styled(DownloadCircleIcon)`
  width: 32px;
  height: 32px;
`
